/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const MapPinLineOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M5.25 21.75h13.5M15 9.75c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm4.5 0c0 6.75-7.5 12-7.5 12s-7.5-5.25-7.5-12c0-1.99.79-3.9 2.2-5.3 1.4-1.41 3.31-2.2 5.3-2.2s3.9.79 5.3 2.2c1.41 1.4 2.2 3.31 2.2 5.3z"
})));
// Fill
const MapPinLineFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M18.75 21h-4.64c.78-.69 1.52-1.44 2.2-2.23 2.58-2.95 3.94-6.08 3.94-9.02 0-2.19-.87-4.29-2.42-5.83C16.29 2.37 14.19 1.5 12 1.5s-4.29.87-5.83 2.42a8.217 8.217 0 0 0-2.42 5.83c0 2.94 1.36 6.07 3.94 9.02.68.79 1.42 1.54 2.2 2.23H5.25a.75.75 0 0 0 0 1.5h13.5a.75.75 0 0 0 0-1.5zM12 6.75a3.006 3.006 0 0 1 2.77 1.85c.23.55.29 1.15.17 1.74-.11.58-.4 1.11-.82 1.53s-.95.71-1.53.82c-.59.12-1.19.06-1.74-.17A3.006 3.006 0 0 1 9 9.75c0-.8.32-1.56.88-2.12s1.32-.88 2.12-.88z"
})));
// DuoTone
const MapPinLineDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 2.25c-1.99 0-3.9.79-5.3 2.2a7.468 7.468 0 0 0-2.2 5.3c0 6.75 7.5 12 7.5 12s7.5-5.25 7.5-12c0-1.99-.79-3.9-2.2-5.3a7.468 7.468 0 0 0-5.3-2.2zm0 10.5a3.006 3.006 0 0 1-2.77-1.85c-.23-.55-.29-1.15-.17-1.74.11-.58.4-1.11.82-1.53s.95-.71 1.53-.82c.59-.12 1.19-.06 1.74.17A3.006 3.006 0 0 1 15 9.75c0 .8-.32 1.56-.88 2.12s-1.32.88-2.12.88z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M5.25 21.75h13.5"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 12.75c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5 9.75c0 6.75-7.5 12-7.5 12s-7.5-5.25-7.5-12c0-1.99.79-3.9 2.2-5.3 1.4-1.41 3.31-2.2 5.3-2.2s3.9.79 5.3 2.2c1.41 1.4 2.2 3.31 2.2 5.3z"
}))));
/**
  Icon MapPinLineIcon in maps group
*/
export const MapPinLineIcon = createIcon('MapPinLineIcon', 'map-pin-line', 'maps', MapPinLineOutline, MapPinLineFill, MapPinLineDuotone, "0 0 24 24");